import React, { useState, useEffect, memo, useRef } from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';

/**
 *
 * @param {TextFieldProps & {number: delay, value: string, onChange: (event: {target: {value: string}}) => void}} param
 * @returns
 */
const DebounceTextField = ({
  delay = 500,
  onChange,
  value,
  actualValue = () => {},
  ...props
}) => {
  const [tempVal, setTempVal] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (!inputRef.current) return;

    if (props.autoFocus) {
      inputRef.current.focus();
    }

    if (props.autoSelect) {
      requestAnimationFrame(() => {
        inputRef.current.select();
      });
    }
  }, [props.autoFocus, props.autoSelect]);

  useEffect(() => {
    if (tempVal === value) return;
    setTempVal(value);
  }, [value]);

  useEffect(() => {
    let timeOutId = null;

    if (tempVal !== value) {
      const newValues = {
        target: {
          name: props.name,
          value: tempVal
        }
      };
      actualValue(newValues?.target?.value);
      timeOutId = setTimeout(() => onChange(newValues), delay);
    }

    return () => {
      if (!timeOutId) return;

      clearTimeout(timeOutId);
    };
  }, [tempVal]);

  const handleChangeValue = e => {
    setTempVal(e.target.value);
  };

  return (
    <TextField
      value={tempVal ?? ''}
      inputRef={inputRef}
      onChange={handleChangeValue}
      {...props}
    />
  );
};

export default memo(DebounceTextField);
